export const EPSL_CONDITIONS = {
	GOOD: 'good',
	FAIR: 'fair',
	NOT_OPERATIONAL: 'notOperational',
};

export const EPSL_CONDITION_DISPLAY_NAMES = {
	[EPSL_CONDITIONS.GOOD]: 'Good',
	[EPSL_CONDITIONS.FAIR]: 'Fair',
	[EPSL_CONDITIONS.NOT_OPERATIONAL]: 'Not Operational',
};

export const ALL_EPSL_CONDITIONS = [
	EPSL_CONDITIONS.GOOD,
	EPSL_CONDITIONS.FAIR,
	EPSL_CONDITIONS.NOT_OPERATIONAL,
];

export const EPSL_DISPOSITION_PLANS = {
	KEEP: 'keep',
	SELL: 'sell',
	DISPOSE: 'dispose',
};

export const EPSL_DISPOSITION_PLAN_DISPLAY_NAMES = {
	[EPSL_DISPOSITION_PLANS.KEEP]: 'Keep',
	[EPSL_DISPOSITION_PLANS.SELL]: 'Sell',
	[EPSL_DISPOSITION_PLANS.DISPOSE]: 'Dispose',
};

export const ALL_EPSL_DISPOSITION_PLANS = [
	EPSL_DISPOSITION_PLANS.KEEP,
	EPSL_DISPOSITION_PLANS.SELL,
	EPSL_DISPOSITION_PLANS.DISPOSE,
];
